import React from 'react'
import { DialogTitle, DialogContent, Dialog, Button, Box } from '@mui/material'
import { Button as DialogButton } from '@/ui'
import styles from './EmlpoyerSignModal.module.scss'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { blockScreen, unblockScreen } from '@/shared'
import { LoadingBlocker } from '@/components/Loader'
import CloseButton from '@/components/CloseButton/CloseButton'
import { useDispatch, useSelector } from 'react-redux'
import { eColContractsSelectors, eColContractsActions, eColContractsThunks } from '@/entity'
import { DigitalSign } from '@/utils/digitalSign'

export const TradeUnionSignModal = ({ onClose, isOpen, externalId, isEmployee }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const digitalSign = new DigitalSign()
	const isLoadingContract = useSelector(eColContractsSelectors.isLoadingContract)
	const signArray = async (xmlArray) => {
		try {
			blockScreen()
			const results = await Promise.all(xmlArray.map((xml) => digitalSign.handleSend(xml)))
			unblockScreen()
			return results
		} catch (error) {
			unblockScreen()
			throw error
		}
	}

	const handleSubmit = () => {
		let body = {
			data: externalId,
			isEmployee,
			onSuccess: async (xml) => {
				try {
					const xmlArray = Array.isArray(xml) ? xml : [xml]
					const signedXml = await signArray(xmlArray)
					const signedBody = {
						data: signedXml,
						onSuccess: () => {
							onClear()
						},
					}
					dispatch(eColContractsThunks.sendSignedColContract(isEmployee, signedBody))
				} catch (error) {
					onClear()
				}
			},
		}
		dispatch(eColContractsThunks.generateTradeUnionXML(body))
	}

	const onClear = React.useCallback(() => {
		dispatch(eColContractsActions.setEColXML(null))
		onClose()
	}, [dispatch, onClose])

	return (
		<Dialog classes={{ paper: styles.sign }} onClose={onClose} open={isOpen}>
			{isLoadingContract ? <LoadingBlocker /> : null}
			<Box>{onClose ? <CloseButton onClose={onClose}></CloseButton> : null}</Box>
			<DialogTitle classes={{ root: styles.sign__title }}>{t('col_contract.text_ecd_sign_trade_union')}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '40px' }}>
				<div className={styles.dialog__buttons__wrapper}>
					<div className={styles.flex_button}>
						<div className={styles.margin_button}>
							<DialogButton type="button" onClick={handleSubmit}>
								{t('sign_button_ecpsdf')}
							</DialogButton>
						</div>
					</div>
					<Button
						type="button"
						variant="text"
						classes={{ root: cn(styles.button, styles.reset__button) }}
						onClick={onClose}
					>
						{t('cancel')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
